import Shadow from '$tablet-app/src/app/components/Shadow';
import React, { FC } from 'react';
import { StyleSheet } from 'react-native';
import { RadioButton } from '../../components/RadioButton/RadioButton';
import Text from '../../components/Text';
import { color, spacing } from '../../theme';
import { ChatOption } from './types';

const BORDER_RADIUS = 10;

interface Props {
  description?: string;
  options: ChatOption[];
  onSelect: (input: string, idx: number) => void;
  selectedIdx?: number;
}

const ChatOptionsItem: FC<Props> = ({
  description,
  options,
  onSelect,
  selectedIdx,
}) => {
  const handleClick = (text: string, idx: number) => {
    if (!selectedIdx) {
      onSelect(text, idx);
    }
  };

  return (
    <Shadow style={styles.root}>
      {description ? (
        <Text style={styles.descriptionText}>{description}</Text>
      ) : null}

      {options?.map((option, idx) => (
        <RadioButton
          key={idx}
          onChange={() => !selectedIdx && handleClick(option.value, idx)}
          checked={selectedIdx === idx}
          label={option.label}
          textStyle={styles.descriptionText}
        />
      ))}
    </Shadow>
  );
};

const styles = StyleSheet.create({
  descriptionText: { fontSize: 24 },
  root: {
    backgroundColor: color.secondary,
    marginBottom: spacing[3],
    marginRight: 'auto',
    maxWidth: '80%',
    padding: spacing[3],
    borderTopRightRadius: BORDER_RADIUS,
    borderTopLeftRadius: BORDER_RADIUS,
    borderBottomLeftRadius: BORDER_RADIUS,
    borderBottomRightRadius: 0,
  },
});

export default ChatOptionsItem;
